import React, { ReactNode } from 'react'
import styled from '@emotion/styled'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'

type Props = {
    children: ReactNode
}

/**
 * ShipCardをchildrenとして受け取り、SPでは縦にPCでは横に並べるコンポーネント
 */
export const ShipCardLayout: React.VFC<Props> = ({
        children
    }) => {
        return <Wrapper>{children}</Wrapper>
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    flex-direction: column;
  }
`
